import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Avatar } from './Avatar';
import { Reveal } from './Reveal';
const points = ['You deal with me directly, not a call center.', 'I call you before any substitution or price change.', 'Clear service fee agreed before you pay a kobo.'];
export function WhyTrustMe() {
  return <section id="why-trust-me" className="w-full bg-white py-14 sm:py-20" data-id="element-223" data-mp="118nyineu2iik">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-4 sm:px-6 md:grid-cols-[auto,1fr] md:gap-14" data-id="element-224" data-mp="dh8vesf8fx69">
        <Reveal className="flex justify-center" data-id="element-225" data-mp="9h8dgxsxd3ug">
          <Avatar size="md" src="https://cdn.magicpatterns.com/uploads/59ignNyjbXUbP4wxEw1TYW/Swift_Errands_CEO.jpg" label="Portrait of the founder of Swift Errands" data-id="element-226" data-mp="9ijjl49uenoq" />
        </Reveal>

        <Reveal delay={0.12} data-id="element-227" data-mp="iiy626yjm8tt">
          <h2 className="text-center font-display text-3xl uppercase tracking-tight text-purple sm:text-4xl md:text-left" data-id="element-228" data-mp="1yuv2bv3bc6tv">
            Why Trust Me
          </h2>
          <p className="mt-2 text-center text-ink/60 md:text-left" data-id="element-229" data-mp="1tvsajcccfx3u">
            One person, one promise: your money and your list are safe with me.
          </p>
          <ul className="mt-6 space-y-4" data-id="element-230" data-mp="1a2jd4p2zmdsr">
            {points.map((point, index) => <Reveal as="li" key={point} delay={0.15 + index * 0.1} className="flex items-start gap-3 text-left" data-id="element-231" data-mp="1f2xc7hmm2den" data-mpi={index}>
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-lavender" data-id="element-232" data-mp="1k20hn36i6ln5">
                  <CheckIcon className="h-4 w-4 text-purple" aria-hidden="true" data-id="element-233" data-mp="mfb8889h16r9" />
                </span>
                <p className="text-base leading-relaxed text-ink/80" data-id="element-234" data-mp="rduxoin9x0od">{point}</p>
              </Reveal>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}